import Typography from '@mui/material/Typography'
import { type TypographyProps } from '@mui/material/Typography'
import React from 'react'

const TypographyComponent: React.FC <TypographyProps> = (props) => {
  return (
<Typography {...props}/>  )
}

export default TypographyComponent